import React from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import '../components/ImageGallery.css';
import l1Image from '../assets/Lavatory/L1.jpg';
import l2Image from '../assets/Lavatory/L2.jpg';
import l3Image from '../assets/Lavatory/L3.jpg';
import Navbar from './Navbar';
import Footer from './Footer';

const MyImageGallery = () => {
  // Sample images data
  const images = [
    {
      original: l1Image,
      thumbnail: l1Image,
      description: 'Lavatory',
    },
    {
      original: l2Image,
      thumbnail: l2Image,
      description: 'Lavatory',
    },
    {
      original: l3Image,
      thumbnail: l3Image,
      description: 'Lavatory',
    },
    // Add more images as needed
  ];

  return (
    <div>
      <Navbar />
      <div className="image-gallery-container">
        <ImageGallery items={images} />
      </div>
      <Footer />
    </div>
  );
};

export default MyImageGallery;
